import ReactECharts from "echarts-for-react";

const BarChart = () => {
  const tooltipFormatter = (params?: any) => {
    return `        
            <div style="display: flex; align-items: center;">
              <span> - : 0 </span>
            </div>
          `;
  };

  // Default options
  const defaultOptions = {
    grid: { top: 30, right: 5, bottom: 50, left: 5 },
    tooltip: {
      formatter: tooltipFormatter,
      backgroundColor: "var(--mui-palette-primary-main)", // Custom background color
      extraCssText: "color: var(--mui-palette-primary-contrastText); padding: 4px 8px; border: 0", // Custom text color and padding
    },
    xAxis: {
      type: "category",
      axisLabel: {
        color: "var(--mui-palette-primary-main)",
        fontSize: 14,
        fontFamily: "Inter",
        fontWeight: 400,
      },
      axisLine: {
        show: false, // Hide the x-axis line
      },
      axisTick: {
        show: false, // Hide the x-axis ticks
      },
      offset: 16,
    },
    yAxis: {
      type: "value",
      max: 150,
      axisLine: {
        show: false, // Hide the y-axis line
      },
      axisTick: {
        show: false, // Hide the y-axis ticks
      },
      axisLabel: {
        show: false, // Hide the y-axis labels
      },
    },
    series: [],
  };

  const options = {
    xAxis: {
      data: ["Mon", "Tue", "Wed", "Thu", "Fri"],
    },
    series: [
      {
        name: "Forest",
        type: "bar",
        data: [5, 5, 5, 5, 5],
        itemStyle: {
          color: "#F2D47D",
          borderRadius: [4, 4, 0, 0],
        },
        barWidth: 20,
        encode: {
          x: 0,
          y: 2,
        },
      },
      {
        name: "Steppe",
        type: "bar",
        data: [5, 5, 5, 5, 5],
        itemStyle: {
          color: "#264653",
          borderRadius: [4, 4, 0, 0],
        },
        barWidth: 20,
        encode: {
          x: 0,
          y: 3,
        },
      },
    ],
  };

  // Merge the default options with the provided options (if any)
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    xAxis: {
      ...defaultOptions.xAxis,
      ...options?.xAxis,
    },
    yAxis: {
      ...defaultOptions.yAxis,
    },
    series: options?.series?.map((userSeries: any, index: any) => ({
      ...(defaultOptions.series[index] as object), // Use default options for the first bar
      ...userSeries,
    })),
  };

  return (
    <ReactECharts
      option={mergedOptions}
      style={{ height: "250px", width: "100%" }}
      opts={{ renderer: "svg" }}
    />
  );
};

export default BarChart;
